import { render, staticRenderFns } from "./triContract.vue?vue&type=template&id=1d6d9dfb&scoped=true"
import script from "./triContract.vue?vue&type=script&lang=js"
export * from "./triContract.vue?vue&type=script&lang=js"
import style0 from "./triContract.vue?vue&type=style&index=0&id=1d6d9dfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6d9dfb",
  null
  
)

export default component.exports